module.exports = __webpack_public_path__ + "static/img/img02.c6124c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductsCenter/img/img02.jpg
// module id = zf7Y
// module chunks = 1